export const get = prop => () => localStorage[prop] ? JSON.parse(localStorage[prop]) : {};
export const del = prop => () => delete localStorage[prop];

export const set = prop => val => {
  localStorage[prop] = JSON.stringify(val || {});
  return val;
};
